import { createSlice } from '@reduxjs/toolkit';

import { IOnePageMenuState } from './IOnePageMenu';
import { OnePageMenuReducer } from '../../reducers/OnePageMenuReducer';

const initialState: IOnePageMenuState = {
	menu: [],
	selected: null,
};

export const onePageMenuSlice = createSlice({
	name: 'one-page-menu',
	initialState,
	reducers: OnePageMenuReducer,
});

export const { initMenu, setSelectedMenu, setKey } = onePageMenuSlice.actions;

export default onePageMenuSlice.reducer;
